import React from "react";
import styled from "styled-components";
import imgHeader from 'static/header-modal.png';
const DropDown = styled.div`
    width: 100%;
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9998;
`

const Label = styled.p`
    font-family: Titillium Bold, sans-serif;
    position: absolute;
    // height: 100%;
    align-content: center;
    font-size: 1.5rem;
    font-weight: 400;
    letter-spacing: 0.1em;
    line-height: 31.82px;
`
const DropBanner = ({ customClass, title, open }) => {
    return (
        <DropDown className={customClass}>
            <img src={imgHeader} />
            <Label className="uppercase">{title}</Label>
        </DropDown>
    )
}
export default DropBanner;